import {
  Box,
  DropsButton,
  DropsExpandable,
  Flex,
  Grid,
  tokens,
} from "shared/components/Spor";
import { ObtrusiveScrollCss } from "shared/components/transitions/scroll";
import styled from "styled-components";

export const ChecklistCustomTableStyle = styled.div`
  padding-top: 6px;
  Table {
    border-collapse: separate;
    border-spacing: 0 6px;
  }

  td,
  th {
    border-bottom: none;
    padding-left: 8px;
    padding-right: 6px;
    background-color: ${({ theme }) => theme.colorBackgroundSecondary};
  }

  th {
    background-color: ${({ theme }) => theme.colorBackgroundSecondary};
  }

  tr > td:first-of-type,
  tr > th:first-of-type {
    border-top-left-radius: ${tokens.default.size["border-radius"].xs};
    border-bottom-left-radius: ${tokens.default.size["border-radius"].xs};
  }

  tr > td:last-of-type,
  tr > th:last-of-type {
    border-top-right-radius: ${tokens.default.size["border-radius"].xs};
    border-bottom-right-radius: ${tokens.default.size["border-radius"].xs};
  }
`;

export const ExpandableHeader = styled.div`
  & {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    align-items: center;

    /* 30px is the Open/Close icon. The icon is provided by Spor so we do this workaround to 'ignore' it */
    width: calc(100% + 30px);
    margin-right: -30px;
  }
`;

export const GridStyled = styled(Grid)`
  grid-template-columns: repeat(7, 1fr);
  padding-left: 15px;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  background-color: ${({ theme }) => theme.colorBackgroundSecondary};
  border-radius: 5px !important;
  font-weight: bold;
  width: 99%;
`;

export const AccordionPanelStyled = styled(Flex)`
  border-radius: 5px !important;
  margin-top: 2px;
  border-top: 0px !important;
  flex-direction: column;
`;

export const ExpandableStyled = styled(DropsExpandable)`
  width: 99%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 12px;
`;

export const EmptyTableText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 600px;
`;

export const LinkOutButton = styled(DropsButton)`
  display: flex;
  align-items: center;
`;

export const ChecklistHistoryWrapper = styled.div`
  container-type: inline-size;
  grid-area: 2 / 1 / 3 / 4;
  box-sizing: border-box;
  width: 100%;
  background-color: ${({ theme }) => theme.colorBackgroundMain};
  ${ObtrusiveScrollCss};
  scrollbar-gutter: sTable;
  overflow-y: auto;
  height: 100%;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colorOutlineSecondary};

  padding-left: 30px;
  padding-right: 30px;
  @container (width < 1200px) {
    .DontShowIfSmallWidth {
      display: none;
    }
  }
`;

// This is a workaround for the overflow issue in the search input
export const NoLabelOverflow = styled(Box)`
  & input {
    width: 300px;
  }
`;

// This is a workaround for the overflow issue in the button
export const NoDivOverflowButton = styled.div`
  margin-left: auto;
  & div {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const NoDivOverflowButtonIcon = styled.div`
  & div {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const LinkOutHideTextWhenNarrow = styled.div`
  max-width:
    80px,
  min-width: 0px;

    & div {
    width: 100%;
  }
  & button {
    width: 100%;
  }
`;

// Used to change font size of button
export const ChangeInternalFontSize = styled.div`
  & span {
    font-size: 18px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const ChangeInternalFontSize2 = styled.div`
  & span {
    font-size: 18px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const CancelButton = styled(DropsButton)`
  outline-color: ${({ theme }) => theme.colorAlarm}!important;
`;
